<template>
    <teleport to="body">
        <div class="min-h-screen bg-gray-100 p-8">

            <Teleport to="body">
                <Transition name="modal">
                    <div

                        @click.self="closeModal"
                        class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
                        role="dialog"
                        aria-labelledby="modal-title"
                        aria-modal="true"
                    >
                        <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
                            <!-- Header -->
                            <div class="px-6 pt-6 pb-4   text-center ">
                                <h2 id="modal-title" class="text-xl font-semibold text-gray-900">
                                    Donnez votre avis sur cet ouvrage
                                </h2>
                            </div>

                            <!-- Contenu -->
                            <div class="px-6 py-6">
                                <!-- Système de notation -->
                                <div class="mb-6">
                                    <div
                                        class="flex items-center justify-center gap-1"
                                        @mouseleave="unhoverRating"
                                        role="radiogroup"
                                        aria-label="Notation sur 5 étoiles"
                                    >
                                        <button
                                            v-for="star in 5"
                                            :key="star"
                                            @click="selectRating(star)"
                                            @mouseenter="hoverRating(star)"
                                            @keydown="handleKeydown($event, star)"
                                            class="p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-150"
                                            :class="{
                                              'text-yellow-400': star <= displayRating,
                                              'text-gray-200': star > displayRating
                                            }"
                                            role="radio"
                                            :aria-checked="star === (rating || props.evaluation?.note)"
                                            :aria-label="`${star} étoile${star > 1 ? 's' : ''}`"
                                            tabindex="0"
                                        >
                                            <svg class="w-10 h-10 fill-current" viewBox="0 0 20 20">
                                                <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <!-- Zone de commentaire -->
                                <div class="mb-6">
                                    <label for="comment" class="block text-sm font-medium text-gray-700 mb-2">
                                        Commentaire <span class="text-gray-400">(facultatif)</span>
                                    </label>
                                    <textarea
                                        id="comment"
                                        v-model="comment"
                                        rows="4"
                                        placeholder="Partagez votre avis sur ce livre..."
                                        class="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                                        maxlength="500"
                                    ></textarea>
                                    <p class="text-xs text-gray-500 mt-1">
                                        {{ comment?.length }}/250 caractères
                                    </p>
                                </div>

                                <!-- Message d'erreur -->
                                <div v-if="error" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                                    <p class="text-sm text-red-600">{{ error }}</p>
                                </div>
                                <!-- Message  -->
                                <div v-if="success" class="mb-4 p-3 bg-red-50 border border-green-200 rounded-lg">
                                    <p class="text-sm text-green-600">{{ error }}</p>
                                </div>
                            </div>

                            <!-- Footer -->
                            <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 rounded-b-xl flex justify-end gap-3">
                                <button
                                    @click="closeModal"
                                    :disabled="isSubmitting"
                                    class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                >
                                    Annuler
                                </button>
                                <button
                                    @click="submitRating(bookId)"
                                    :disabled="isSubmitting"
                                    class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-2"
                                >
                                    <svg v-if="isSubmitting" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    {{ isSubmitting ? 'Envoi...' : 'Envoyer l\'évaluation' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </Transition>
            </Teleport>
        </div>
    </teleport>
</template>
<script setup>
import {ref, computed, watch, reactive, onMounted, nextTick} from 'vue'
import {NotificationToast} from "@/utils/notification.js";


const props=defineProps({
    bookId: {
        type:Number,
        required:true
    },
    evaluation: {
        type: Object,
        default: {}
    }
})
const emit=defineEmits(['close','updateState'])
// État de la modale
const error = ref('')
const isSubmitting = ref(false)
const success=ref('')
const rating=ref( 0)
const comment = ref(props.evaluation?.commentaire || '')
const hoveredRating = ref(0)
const displayRating = computed(() => hoveredRating.value || rating.value || props.evaluation?.note )
const closeModal = () => {
    emit('close',false)
}
const selectRating = (stars) => {
    rating.value = stars
    error.value = ''
}

const hoverRating = (stars) => {
    hoveredRating.value = stars
}

const unhoverRating = () => {
    hoveredRating.value = 0
}

const handleKeydown = (event, stars) => {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        selectRating(stars)
    }
}

// Soumettre l'évaluation
const submitRating = async (bookId) => {
    if (rating.value === 0) {
        error.value = 'Veuillez sélectionner une note'
        return
    }

    isSubmitting.value = true

    try {
        const formData = new FormData()
        formData.append('note', rating.value)
        formData.append('commentaire', comment.value)
        const response = await axios({
            method: 'POST',
            url: `/note/`+bookId,
            data: formData
        })
        if (response.data) {
            NotificationToast(response.data.type,response.data.message)
            success.value = response.data
            emit('updateState')
            closeModal()
        }
    } catch (err) {
        error.value = 'Une erreur est survenue. Veuillez réessayer.'
    } finally {
        isSubmitting.value = false
    }
}
</script>
<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.5s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .bg-white,
.modal-leave-active .bg-white {
    transition: transform 0.5s ease;
}

.modal-enter-from .bg-white,
.modal-leave-to .bg-white {
    transform: scale(0.95);
}
</style>
